export const numberWithCommas = (value: number, precision?: number) => {
  return value.toFixed(precision).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const numberRoundDownWithDecimals = (value: number, precision = 2) => {
  return (Math.trunc(value * 10 ** precision) / 10 ** precision).toFixed(precision);
};

export const formatNumberWithDecimals = (value: number, precision = 2) => {
  const truncated = Math.trunc(value * 10 ** precision) / 10 ** precision;

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: precision,
  });

  return formatter.format(truncated);
};

export const formatDrift = (drift: number) =>
  Math.abs(drift) < 0.1 ? '<0.1' : `${formatNumberWithDecimals(drift, 1)}`;
